import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import SizeTypeItem from '../SizeTypeItemComponent';
import ContainerInfoComponent from '../ContainerInfoComponent';
import Sidebar from '../../../ReusableComponents/Sidebar';

export default function ContainerSelectionBody({
  sizeTypes,
  selectedSize,
  setSelectedSize,
  selectedLevel,
  setSelectedLevel,
  showPlacementBody,
  setShowPlacementBody,
  roomList,
  handleNext,
}) {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  //Sort the sizeTypes ones with available containers to the top, so that the user can easily see which ones are available and select them. The ones without available containers will be at the bottom of the list and can be selected, but they will show as unavailable in the UI.
  if (Array.isArray(sizeTypes) && sizeTypes.length > 0) {
    sizeTypes.sort((a, b) => (b.availableAmount > 0) - (a.availableAmount > 0));
  }

  // We should auto pick the first available size type, if there is one, to avoid an empty right side of the screen
  useEffect(() => {
    if (!selectedSize && Array.isArray(sizeTypes) && sizeTypes.length > 0) {
      for (const type of sizeTypes) {
        if (type.availableAmount > 0) {
          setSelectedSize(type);
          break;
        }
      }
    }
  }, [sizeTypes, selectedSize, setSelectedSize]);

  // Handle size selection - open sidebar on mobile
  const handleSizeSelect = type => {
    setSelectedSize(type);
    setSidebarOpen(true);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-12">
      <div className="w-[85%] mx-auto col-span-1 md:col-span-7">
        <div className="mt-4 mb-4 containerList">
          <div className="flex justify-between items-center">
            <div className="font-bold text-lg">{t('see_all_sizes')}</div>
            <div className="text-sm">{t('containers_are_dry_and_clean')}</div>
          </div>
        </div>
        <div className="mt-4 containerListitems flex flex-col gap-4">
          {Array.isArray(sizeTypes) && sizeTypes.length > 0 ? (
            sizeTypes.map(type => (
              <SizeTypeItem
                key={type.id}
                type={type}
                selectedSize={selectedSize}
                setSelectedSize={handleSizeSelect}
                setSelectedLevel={setSelectedLevel}
              />
            ))
          ) : (
            <div className="text-gray-500 text-center py-8">
              {t('no_containers_available')}
            </div>
          )}
        </div>
        <div className="p-4 text-sm text-gray-600 flex flex-col gap-2">
          <p>{t('pick_size_container_list_small_text')}</p>
        </div>
      </div>

      {/* Desktop: show inline */}
      <div className="hidden md:block col-span-1 md:col-span-5">
        {selectedSize && (
          <ContainerInfoComponent
            roomList={roomList}
            selectedSize={selectedSize}
            selectedLevel={selectedLevel}
            setSelectedLevel={setSelectedLevel}
            showPlacementBody={showPlacementBody}
            setShowPlacementBody={setShowPlacementBody}
            handleNext={handleNext}
          />
        )}
      </div>

      {/* Mobile: show in sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onOpen={selectedSize ? () => setSidebarOpen(true) : null}
        openLabel={t('view_details')}
      >
        {selectedSize && (
          <ContainerInfoComponent
            roomList={roomList}
            selectedSize={selectedSize}
            selectedLevel={selectedLevel}
            setSelectedLevel={setSelectedLevel}
            showPlacementBody={showPlacementBody}
            setShowPlacementBody={setShowPlacementBody}
            handleNext={handleNext}
            onClose={() => setSidebarOpen(false)}
          />
        )}
      </Sidebar>
    </div>
  );
}
